var map = {
	"./computer/TokenDetail/TokenDetail.vue": [
		"2fd0",
		"chunk-4bf2e6a0"
	],
	"./mobile/TokenDetail/TokenDetail.vue": [
		"a878",
		"chunk-0e44524d"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "92753";
module.exports = webpackAsyncContext;